import { dispatch, ErrorVariants, showToast } from '@zonofi/zono-money-store';

export const processOrderPatchResponse = (
  response: any,
  onSuccess: () => void,
  fallbackSuccesMessage?: string,
  fallbackErrorMessage: string = 'Something went wrong'
) => {
  if (response.isSuccess && response.data?.errors?.length > 0) {
    const errMsg = response.data.errors[0];
    const derivedErrorMessage =
      typeof errMsg === 'string' ? errMsg : errMsg?.msg || fallbackErrorMessage;

    dispatch(
      showToast({
        message: derivedErrorMessage,
        type: ErrorVariants.DANGER,
        canDisplay: true,
        responseStatus: 'Error',
      })
    );
  } else if (response.isSuccess && response.data) {
    onSuccess?.();

    const successMessage = fallbackSuccesMessage || response.data?.message;
    if (successMessage) {
      dispatch(
        showToast({
          message: successMessage,
          type: ErrorVariants.SUCCESS,
          canDisplay: true,
          responseStatus: 'Success',
        })
      );
    }
  } else if (response.isError) {
    dispatch(
      showToast({
        message: fallbackErrorMessage,
        type: ErrorVariants.DANGER,
        canDisplay: true,
        responseStatus: 'Error',
      })
    );
  }
};
